module.exports = __webpack_public_path__ + "static/media/3.04831ffe.JPG";